import { DeliveryForecastDespatchAdvicePackagingItem } from '../../data/models'

export interface PackagingItemHierarchyRestrictions {
  isParentMandatory: boolean
  allowedParentTypes:
    | DeliveryForecastDespatchAdvicePackagingItem['PackagingType'][]
    | null
}

export function getPackagingItemHierarchyRestrictions(
  item:
    | DeliveryForecastDespatchAdvicePackagingItem
    | DeliveryForecastDespatchAdvicePackagingItem['PackagingType'],
): PackagingItemHierarchyRestrictions {
  const packagingType = getPackagingType(item)

  switch (packagingType) {
    case 'Master':
      return {
        isParentMandatory: false,
        allowedParentTypes: null,
      }

    case 'Single':
      return {
        isParentMandatory: false,
        allowedParentTypes: ['Master'],
      }

    case 'Helper':
      return {
        isParentMandatory: true,
        allowedParentTypes: ['Master', 'Single'],
      }

    default:
      throw new Error(`Invalid PackagingType`)
  }
}

function getPackagingType(
  item:
    | DeliveryForecastDespatchAdvicePackagingItem
    | DeliveryForecastDespatchAdvicePackagingItem['PackagingType'],
): DeliveryForecastDespatchAdvicePackagingItem['PackagingType'] {
  if (typeof item === 'string') {
    return item
  } else {
    return item.PackagingType
  }
}
